export const zhCnLocale = {
  model: {
    banner: '轮播图'
  },
  banner: {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    target: '目标',
    position: '优先级',
    pagePosition: '页面位置',
      pagePositions: {
        event: 'Event',
      },
    kind: '类型',
      kinds: {
        web_link: '网站链接',
        image: '纯图片',
        mp_link: '小程序链接',
      },
    alt: '图片描述',
    image: '图片',
  }
}

export const enLocale = {
  model: {
    banner: 'Banner'
  },
  banner: {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    target: 'Target',
    position: 'Position',
    pagePosition: 'Page position',
      pagePositions: {
        event: 'Event',
      },
    kind: 'Kind',
      kinds: {
        web_link: 'Web link',
        image: 'Image',
        mp_link: 'Mini program link',
      },
    alt: 'Alt',
    image: 'Image',
  }
}

